import { PdPricetable } from "./pd-pricetable/PdPricetable.js";
//#region src/pd-pricetable/pd-pricetable.ts
var tag = "pd-pricetable";
if (!customElements.get(tag)) customElements.define(tag, PdPricetable);
//#endregion
export { PdPricetable };
